import { CDK_DRAG_CONFIG, DragDropConfig } from '@angular/cdk/drag-drop';

/**
 * A `cdkDrag` starts on a 5px move, so on a touch screen every swipe over a draggable card turned
 * into a drag and the board under it never scrolled. A finger now has to hold the item first; a
 * swipe that moves sooner scrolls as usual. The mouse still drags at once.
 */
export const provideDragDropDefaults = () => ({
  provide: CDK_DRAG_CONFIG,
  useValue: { dragStartDelay: { touch: 300, mouse: 0 } } satisfies DragDropConfig,
});
